import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class PersonService extends BaseService {
	constructor() {
		super('/Person');
	}


	public getAllByFilter(filter: PersonFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class PersonFilter extends BaseFilter {
	constructor(idGroup?: number | null, idTenant?: number | null, isDeleted?: boolean | null) {
		super();
		this._idGroup = idGroup;
		this._idTenant = idTenant;
		this._isDeleted = isDeleted;
	}

	private _idGroup?: number | null;
	private _idTenant?: number | null;
	private _isDeleted?: boolean | null;
	
	public getAllParams(): {} {
	
		let data = Object.assign({},
			(this._idGroup != null ? { IdGroup: this._idGroup } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {})
		);
	
		return data;
	};
}